/* eslint-disable */
import { OffersHttpResponse } from '../models/offers.http.response.model';
import { OfferStatus } from '../models/offer.model';
import { Status, Description } from '../models/service.model';
import { OfferType } from '../models/replacement.offer.model';
import { mockXCorrelationId } from '../mocks/x.correlation.id.mock';

export const mockOffersHttpResponse: OffersHttpResponse = {
  headers: {
    headers: [
      {
        key: 'x-correlation-id',
        value: mockXCorrelationId,
      },
    ],
  },
  body: {
    offer: {
      offerReference: '205b8cb4-7169-4dec-95e7-f344f26bf6e7',
      offer_status: OfferStatus.AVAILABLE,
      number_of_replacements: 6,
      number_of_upgrades: 6,
      upsell_flag: true,
      rrp_flag: true,
      outstanding_dd_amount: 99,
      outstanding_dd_count: 12,
    },
    current_plan: {
      client_code: '00351',
      client_group_code: '00296',
      plan_category: 'S',
      plan_number: 'ORB0000150',
      company_code: 'D',
      scheme_code: 'T3F',
      reference_number: '0005123',
    },
    contact_details: {
      forename: 'SHABA',
      surname: 'MORETON-AAAQ',
      person_gid: '3697141',
    },
    delivery_address: {
      address_line_1: '28 HEPPLESTONE CLOSE',
      address_line_2: 'LONDON',
      address_line_3: 'LONDON',
      postal_code: 'SW15 5DE',
      country_code: 'GBR',
    },
    person_owner_eid: '3697141',
    current_item: {
      make: 'Bosch',
      model: 'WAN28080GB',
      colour: 'Silver',
      short_description: 'Bosch WAN28080GB Washing Machine',
      long_description: 'Bosch WAN28080GB Washing Machine Silver A+++ 7 1400',
      images: [
        {
          text: '',
          url: 'https://validatorimages.azureedge.net/large/2147012039.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '550',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+++',
        },
        {
          name: 'Height',
          value: '848',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Bosch',
        },
        {
          name: 'ReleaseDate',
          value: 'Jul  1 2016 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'B',
        },
        {
          name: 'Spin Speed',
          value: '1400',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '7',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '598',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      purchase_price: 300,
      appliance_category: 'Washing Machine',
    },
    replacement_offers: [
      {
        item_code: 'AW',
        warranty: 12,
        manuf_code: 'BEKO',
        make: 'BEKO',
        model: 'WTG620M2W',
        colour: 'White',
        offer_type: OfferType.UPGRADE,
        display_order: 1,
        upgrade_fee: 205,
        rrp: 215.42,
        article_id: 2146903247,
        appliance_category: 'Washing Machine',
        short_description: 'BEKO WTG620M2W Washing Machine',
        long_description: 'BEKO WTG620M2W Washing Machine White A+++ 6 1200',
        selected: true,
        supplier_name: 'RGB',
        cat_num: 'WTG620M2W',
        supplier_id: 6684,
        services: [
          {
            cat_num: 'DELRGB',
            charge_type: 1,
            status: Status.F,
            description: Description.Delivery,
            price_net: 0,
            price_gross: 0,
            charge_customer: false,
          },
          {
            cat_num: 'INSRGB',
            charge_type: 2,
            status: Status.C,
            description: Description.Installation,
            price_net: 16.666666,
            price_gross: 20,
            charge_customer: true,
          },
          {
            cat_num: 'REMOVALRGBWM',
            charge_type: 3,
            status: Status.C,
            description: Description.Disposal,
            price_net: 10,
            price_gross: 12,
            charge_customer: true,
          },
        ],
        summary_specs: [
          'Slim depth',
          'Large porthole door',
          'Hand wash program',
          'Child safety lock',
        ],
        images: [
          {
            text: 'Front',
            url: 'https://cdn.cnetcontent.com/8d/7f/8d7f1746-55f1-441a-90fe-9f70ccac637a.jpg',
          },
        ],
        compare_specs: [
          {
            name: 'Bluetooth',
            value: 'No',
          },
          {
            name: 'Construction',
            value: 'Freestanding',
          },
          {
            name: 'Delay Timer',
            value: 'Yes',
          },
          {
            name: 'Depth',
            value: '415',
          },
          {
            name: 'Energy Efficiency',
            value: 'A+++',
          },
          {
            name: 'Height',
            value: '840',
          },
          {
            name: 'Loading',
            value: 'Front Loader',
          },
          {
            name: 'Make',
            value: 'Beko',
          },
          {
            name: 'ReleaseDate',
            value: 'Aug 30 2017 12:00AM',
          },
          {
            name: 'Spin Efficiency',
            value: 'B',
          },
          {
            name: 'Spin Speed',
            value: '1200',
          },
          {
            name: 'Type',
            value: 'Washing machine',
          },
          {
            name: 'Wash Capacity',
            value: '6',
          },
          {
            name: 'Wash Efficiency',
            value: 'A',
          },
          {
            name: 'Width',
            value: '600',
          },
          {
            name: 'WiFi',
            value: 'No',
          },
        ],
        detailed_specs: [
          {
            name: 'Product Description',
            value:
              'Beko WTG620M2 washing machine - front loading - freestanding - white',
          },
          {
            name: 'Product Type',
            value: 'Washing machine - front loading',
          },
          {
            name: 'Energy Class',
            value: 'Class A+++',
          },
          {
            name: 'Loading Capacity',
            value: '6 kg',
          },
          {
            name: 'Energy Consumption per Year',
            value: '152 kWh',
          },
          {
            name: 'Water Consumption per Year',
            value: '8799 liters',
          },
          {
            name: 'Spin Class',
            value: 'Class B',
          },
          {
            name: 'Spin Speed',
            value: 'Variable - 1200 rpm (max)',
          },
          {
            name: 'Residual Moisture',
            value: '53%',
          },
          {
            name: 'Noise Level (Washing)',
            value: '62 dB',
          },
          {
            name: 'Noise Level (Spinning)',
            value: '77 dB',
          },
          {
            name: 'Maximum Noise Level',
            value: '77 dB',
          },
          {
            name: 'Form Factor',
            value: 'Freestanding',
          },
          {
            name: 'Color',
            value: 'White',
          },
          {
            name: 'Control Type',
            value: 'Electronic',
          },
          {
            name: 'Washer Drum Capacity',
            value: '39 liters',
          },
          {
            name: 'Washing Efficiency',
            value: 'Class A',
          },
          {
            name: 'Programs Qty',
            value: '15',
          },
          {
            name: 'Safety Features',
            value:
              'Water overflow protection system, electromechanical door lock, ChildLock',
          },
          {
            name: 'Energy Consumption per Cycle',
            value: '0.78 kWh',
          },
          {
            name: 'Water Consumption per Cycle',
            value: '40 liters',
          },
          {
            name: 'Voltage',
            value: '230 V / 50 Hz',
          },
          {
            name: 'Dimensions (WxDxH)',
            value: '60 cm x 41.5 cm x 84 cm',
          },
          {
            name: 'Weight',
            value: '56 kg',
          },
          {
            name: 'Standard Washing Program',
            value: 'Cotton',
          },
          {
            name: 'Door Opening Angle',
            value: '170 degrees',
          },
          {
            name: 'Door Opening Diameter',
            value: '30 cm',
          },
          {
            name: 'Out-Of-Balance Detection',
            value: 'Yes',
          },
          {
            name: 'Exterior Color',
            value: 'White',
          },
          {
            name: 'Drum Material',
            value: 'Stainless steel',
          },
          {
            name: 'Average Cycle Time',
            value: '250 minutes',
          },
          {
            name: 'Timer Settings Features',
            value: 'Start timer delay',
          },
          {
            name: 'Maximum Start Timer Delay',
            value: '9 hours',
          },
          {
            name: 'Indicators',
            value: 'Wash progress indicator',
          },
          {
            name: 'Type',
            value: 'Digital',
          },
          {
            name: 'Special Programs & Options',
            value:
              'Daily wash, half-load, quick wash, pre-wash, cotton, synthetics, hand wash, dark garments, Baby, drain + spin, cotton eco, rinse hold, extra rinse, rinse, mix, drum cleaning',
          },
          {
            name: 'Wheels & Leveling',
            value: 'Adjustable feet',
          },
          {
            name: 'Water Connection',
            value: 'Cold',
          },
          {
            name: 'Max Power Consumption',
            value: '1550 W',
          },
          {
            name: 'Power Consumption Off-Mode',
            value: '0.25 W',
          },
          {
            name: 'Power Consumption Left-on Mode',
            value: '0.75 W',
          },
          {
            name: 'Rated Current',
            value: '10 A',
          },
          {
            name: 'Width',
            value: '60 cm',
          },
          {
            name: 'Depth',
            value: '41.5 cm',
          },
          {
            name: 'Height',
            value: '84 cm',
          },
          {
            name: 'Width (Shipping)',
            value: '65 cm',
          },
          {
            name: 'Depth (Shipping)',
            value: '46.5 cm',
          },
          {
            name: 'Height (Shipping)',
            value: '88 cm',
          },
          {
            name: 'Weight (Shipping)',
            value: '57 kg',
          },
        ],
      },
    ],
  },
};
